import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const bloqueioService = {
    post: (values:any) => {
        return api.post(`${OperacoesWebAPI.Bloqueio}`, values)
            .then((res) => res)
            .catch(err => err)
    },
    get: () => {
        return api.get(`${OperacoesWebAPI.Bloqueio}`)
            .then((res) => res)
            .catch(err => err)
    },
    put: (values:any) =>{
        return api.put(`${OperacoesWebAPI.Bloqueio}`, values)
        .then((res) => res)
        .catch(err => err)
    }
}